export function IsLocalHost() {
    let host: string = window.location.host;
    return host.includes('localhost');
}

export function IsStaging() {
    let host: string = window.location.host;
    return host.includes('test');
}
